$(function() {

	// Select to dropdown initialization
	$('.Form__Element select').renderSelectToDropdownElements();
	$('.select-to-dropdown').selectToDropdown();


	// Collapse button text replacer
	function textReplacer(el) {
		el.each(function() {
			var $this = $(this);

			if ($this.attr('data-replace') !== '' && $this.attr('data-replace') !== undefined) {
				var textTarget = ($this.find('> span').length) ? $this.find('> span') : $this,
					text = textTarget.text(),
					replacerText = $this.attr('data-replace');

				textTarget.text(replacerText);

				$this.attr('data-replace', text);
			}
		});
	}


	// Replace text in collapse button when needed
	$('.collapse').each(function() {
		$(this).on('show.bs.collapse', function() {
			var collapseID = $(this).attr('id');
			textReplacer($('[aria-controls=' + collapseID + '][data-replace]'));
		}).on('hide.bs.collapse', function() {
			var collapseID = $(this).attr('id');
			textReplacer($('[aria-controls=' + collapseID + '][data-replace]'));
		});
	});


	// Render controls element
	if ($('body').data('show-grid-overlay') === true || $('body').data('show-image-specs') === true  || $('body').data('show-alert-controls') === true) {
		$('<div>')
			.addClass('helper-controls container')
			.prependTo('.site-header-surround')
			.css({
				'position': 'fixed',
				'width': 'auto',
				'top': '0',
				'left': '0',
				'font-size': '11px',
				'padding': '3px 7px',
				'z-index': '20000',
				'background': '#fff',
				'border-bottom-right-radius': '3px',
			});
	}


	// Show alert controls
	if ($('body').data('show-alert-controls') === true) {
		$('<span>')
			.addClass('alert__controls')
			.css('display', 'inline-block')
			.appendTo('.helper-controls');

		$('<input>')
			.attr('type', 'checkbox')
			.attr('id', 'showAlertExample')
			.css('margin-left', '10px')
			.appendTo('.alert__controls');

		$('<label>')
			.attr('for', 'showAlertExample')
			.text('Alert')
			.css('margin-left', '10px')
			.css('margin-bottom', '0')
			.insertAfter('#showAlertExample');


		$('#showAlertExample').on('change', function() {
			var $this = $(this);

			if ($this.is(':checked')) {
				$('.page-alert')
					.not('.site-main .page-alert')
					.addClass('d-block')
					.removeClass('d-none');
			} else {
				$('.page-alert')
					.not('.site-main .page-alert')
					.removeClass('d-block')
					.addClass('d-none');
			}
		});
	}


	// Initialize grid overlay
	$.fn.gridOverlay({
		'outerPadding': '30px',
		'controlsParentSelector': '.helper-controls'
	});


	// Initialize image spec tags
	$.fn.imageSpecs({
		'imageExcludeSelectors': '.site-header__logo-full, .site-header__logo-acronym, .site-footer__logo',
		'linkColor': '#005587',
		'controlsParentSelector': '.helper-controls'
	});
	
	$.fn.fontSpecs();


	// If jump to target is in a collapse/accordion open accordion and jump to interval
	$('[href^="#"]').not('[data-toggle="collapse"], [href="#"]').on('click', function(e) {
		var $anchor = $(this),
			anchorTargetEl = $($anchor.attr('href'));

		if (anchorTargetEl.length) {
			e.preventDefault();

			anchorTargetEl
				.closest('.collapse')
				.collapse('show');

			$('html, body').animate({
				scrollTop: anchorTargetEl.offset().top
			}, 300);
		}
	});


	// Bold first word in icon row	
	$('.icon-cta__info').boldFirstWord();


	// Add link arrows in spots we can't do it on the backend
	$('a.link-arrow-right, a.arrow-right').linkArrow('ml-1');
	$('.icon-cta__info').linkArrow('fs-12px d-inline ml-n1');


	// Randomize speakers and stick some in collapse
	$('.headshot-grid').each(function() {
		var $hsGrid = $(this);
		var hsGridRow = $hsGrid.find('.row:first');
		var hsGridCollapseRow = $hsGrid.find('.collapse .row');
		
		hsGridRow.randomizeEntries('.col-sm-6');
		
		if (hsGridRow.find('.col-sm-6').length > 2) {
			hsGridRow.moveIntoCollapse('.col-sm-6', hsGridCollapseRow, 2);
		} else {
			$hsGrid
				.addClass('show')
				.find('.collapse, [data-toggle="collapse"]')
				.addClass('d-none');
		}
	});


	// Randomize programmings and stick some in collapse
	$('.featured-progamming').each(function() {
		var $fp = $(this);
		var fpEntriesContainer = $fp.find('.featured-progamming-entries');
		var fpCollapse = $fp.find('.collapse');

		fpEntriesContainer.randomizeEntries('.row.gutter-40px');
	
		if ($fp.find('.row.gutter-40px').length > 4) {
			fpEntriesContainer.moveIntoCollapse('.row.gutter-40px', fpCollapse, 4);
		} else {
			$fp
				.addClass('show')
				.find('.collapse, [data-toggle="collapse"]')
				.addClass('d-none');
		}
	});
	
	
	// Add inner span to rich text article h3s
	$('.rich-text-editor.rich-text-editor--article h3').each(function(){
		var $heading = $(this);
				
		if ($heading.hasClass('')) {
			$heading.wrapInner('<span></span>');
		}
	});
	
	// Add inner span to rich text h6s
	$('.rich-text-editor:not(.rich-text-editor--article) h6').each(function(){
		var $heading = $(this);
				
		if ($heading.hasClass('')) {
			$heading.wrapInner('<span></span>');
		}
	});

	// Wrap youtube iframe in rich text area with responsive embed element
	$('.rich-text-editor iframe').each(function() {
		var iframe = $(this);
		var iframeSrc = iframe.attr('src');

		if (
			iframeSrc.match(/^(https?:\/\/)?((www\.)?youtube\.com|youtu\.be)\/.+$/) &&
			iframe.closest('.embed-responsive').length === 0
		) {
			iframe
				.addClass('embed-responsive-item')
				.wrap('<div class="embed-responsive embed-responsive-16by9">');
		}
	});

	// Scroll accordion content into view if needed
	$('.accordion .collapse').each(function() {
		var $collapse = $(this);
		var buttonSelector = $('#' + $collapse.attr('aria-labelledby'));

		$collapse.on('shown.bs.collapse', function () {
			var buttonTop = buttonSelector.offset().top;
			var windowTop = $(window).scrollTop();
			var scrollMarginTop = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--scroll-top-spacing').replace('px', ''));

			if (buttonTop - windowTop < scrollMarginTop) {
				buttonSelector[0].closest('.accordion-item').scrollIntoView({
					block: 'start',
					behavior: 'auto'
				});
			}
		});
	});

	$('[data-toggle="tooltip"]').tooltip();

	$('[data-toggle="popover"]').popover();
	
	$('.js-copy-btn').each(function() {
		var copyBtn = $(this);
		var origMsg = copyBtn.attr('data-original-title');

		copyBtn.on('click', function(e) {
			e.preventDefault();
			navigator.clipboard.writeText(window.location.href);
			copyBtn
				.attr('data-original-title', 'Copied')
				.tooltip('show');
		}).on('mouseleave', function() {
			copyBtn
				.attr('data-original-title', origMsg)
				.tooltip('hide');
		});
	});

	// Move modal element to bottom of body tag
	$('.modal').appendTo('body');
});